import FetcherFactory from "../../_shared/Fetcher/factory";
import HTTPAdmissionRepository from "./HTTPAdmissionRepository";

export const httpAdmissionRepository = () =>
  new HTTPAdmissionRepository(FetcherFactory.httpFetcher);
